import React from "react";

const roundActionClasses =
    "inline-flex flex-shrink-0 items-center justify-center rounded-full border border-gray-300 bg-white p-1.5 text-brand-700 " +
    "hover:bg-brand-100 hover:text-brand-800 " +
    "focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-500";

const roundActionIconClasses = "w-4 h-4";

type RoundActionIcon = React.ComponentType<React.SVGProps<SVGSVGElement>>;

interface RoundActionButtonProps {
    title: string;
    Icon: RoundActionIcon;
    onClick: () => void;
}

export const RoundActionButton: React.FC<RoundActionButtonProps> = props => {
    const { title, Icon, onClick } = props;

    return (
        <button
            type="button"
            title={title}
            aria-label={title}
            onClick={onClick}
            className={roundActionClasses}>
            <Icon aria-hidden="true" className={roundActionIconClasses} />
        </button>
    );
};

interface RoundActionLinkProps {
    title: string;
    Icon: RoundActionIcon;
    href: string;
}

export const RoundActionLink: React.FC<RoundActionLinkProps> = props => {
    const { title, Icon, href } = props;

    return (
        <a href={href} title={title} aria-label={title} className={roundActionClasses}>
            <Icon aria-hidden="true" className={roundActionIconClasses} />
        </a>
    );
};

interface RoundActionTriggerProps {
    title: string;
    Icon: RoundActionIcon;
    href: string;
    onClick: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

export const RoundActionTrigger: React.FC<RoundActionTriggerProps> = props => {
    const { title, Icon, href, onClick } = props;

    return (
        <a
            href={href}
            title={title}
            aria-label={title}
            onClick={onClick}
            className={roundActionClasses}>
            <Icon aria-hidden="true" className={roundActionIconClasses} />
        </a>
    );
};

export const RoundActionExternalLink: React.FC<RoundActionLinkProps> = props => {
    const { title, Icon, href } = props;

    return (
        <a
            href={href}
            title={title}
            aria-label={title}
            target="_blank"
            rel="noreferrer"
            className={roundActionClasses}>
            <Icon aria-hidden="true" className={roundActionIconClasses} />
        </a>
    );
};
